export default __webpack_public_path__ + "static/media/eyal_eithcowich.94fbff0d.png";